import {Dispatch, SetStateAction} from 'react'

import {ShutdownHistoryActions} from './ShutdownHistoryActions'
import {ShutdownHistoryLabel} from './ShutdownHistoryLabel'
import {ShutdownHistorySearch} from './ShutdownHistorySearch'

export interface ShutdownHistoryCardHeaderProps {
  setTextFilter: Dispatch<SetStateAction<string>>
  textFilter: string
}
export const ShutdownHistoryCardHeader = ({
  textFilter,
  setTextFilter
}: ShutdownHistoryCardHeaderProps) => {
  return (
    <div className={'flex flex-col gap-4'}>
      <div
        className="flex flex-col md:flex-row gap-4 md:gap-0 justify-between items-center"
        data-cy="kiln_shutdowns_card_header"
      >
        <ShutdownHistoryLabel />
        <ShutdownHistoryActions />
      </div>
      <div>
        <ShutdownHistorySearch setTextFilter={setTextFilter} textFilter={textFilter} />
      </div>
    </div>
  )
}
